import { render, staticRenderFns } from "./DispatchCustomers.vue?vue&type=template&id=0295b3a5&scoped=true"
import script from "./DispatchCustomers.vue?vue&type=script&lang=js"
export * from "./DispatchCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0295b3a5",
  null
  
)

export default component.exports